<template>
  <div :class="$style.formContainer">
    <transition :name="$style.fade">
      <LoginCard
        key="resetPassword"
        header="User Password Reset"
      >
        <Alert :message="errorMessage" />
        <ResetPassword
          :clientType="clientType"
          :isLoading="isLoading"
          :form="form"
          :ref="formRef"
          :submit="submit"
        />
      </LoginCard>
    </transition>
    <LogoIcon />
  </div>
</template>

<script>
import { LoginConsts } from 'client/util/Constants';
import ConfirmValidation from 'client/components/mixins/ConfirmValidation';
import LoginCard from 'client/components/LoginCard.vue';
import ResetPassword from 'client/components/forms/ResetPassword.vue';
import RouteGenerator, { UserRoutes } from 'client/routes/RouteGenerator';
import api from 'client/api';
import loginResponseHandlers, { passwordResetErrorHandler } from 'client/containers/Login/LoginResponseHandlers';
import loginUtil from 'client/components/mixins/loginUtil';

const { formElements } = LoginConsts;

const { formRef } = formElements;
const { login } = RouteGenerator;

export default {
  name: 'UserResetPassword',

  mixins: [
    loginUtil,
    ConfirmValidation,
    loginResponseHandlers,
  ],

  components: {
    LoginCard,
    ResetPassword,
  },

  props: {
    requestKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: {
        confirm: '',
        confirmationCode: this.requestKey,
        password: '',
        otp: '',
      },
    };
  },

  created() {
    const { $style } = this;
    this.formRef = formRef;
    this.transitionProps = {
      enterClass: $style.fadeUpEnter,
      enterActiveClass: $style.fadeUpEnterActive,
      leaveActiveClass: $style.fadeUpLeaveActive,
      leaveToClass: $style.fadeUpLeaveTo,
      tag: 'div',
    };
  },

  mounted() {
    const message = this.$route.query.error;

    if (message) {
      this.setErrorMessage(message);
    }
  },

  methods: {
    async request() {
      const {
        passwordResetSuccessHandler,
        mfaRedirectHandler,
        setErrorMessage,
      } = this;

      let res;

      try {
        const deviceCode = await this.getDeviceCertCode();
        res = await api[this.clientType].resetPassword(this.requestKey, {
          ...this.form,
          deviceCode,
        });
      } catch (e) {
        const result = passwordResetErrorHandler(e);

        if (result instanceof Error) {
          this.isLoading = false;
          return setErrorMessage(result.message);
        }

        const deviceCode = await this.getDeviceCertCode();

        return mfaRedirectHandler(result, {
          passwordResetInfo: {
            ...this.form,
            deviceCode,
            pwdResetToken: result.pwdResetToken,
          },
          context: LoginConsts.passwordReset,
          redirectTo: login,
        });
      }

      this.isLoading = false;

      const { email, totpKey } = res.data;
      const redirectUrl = totpKey ? UserRoutes.setupMFA(totpKey, email) : login;

      return passwordResetSuccessHandler(redirectUrl);
    },

    async getDeviceCertCode() {
      try {
        const res = await api[this.clientType].requestDeviceCode();
        return res.data.code;
      } catch {
        return null;
      }
    },
  },
};
</script>

<style module>
@import '../css/login-components.css';

.fadeUp {
  width: 100%;
}

.fadeUp-enter-active {
  transition: opacity 0.35s 0.35s;
}

.fadeUp-leave-active {
  transition: opacity 0.35s;
}

.fadeUp-enter,
.fadeUp-leave-to {
  opacity: 0;
}

.transitionContainer {
  position: relative;
  width: 100%;
}

</style>
